var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgSeasoning = function SvgSeasoning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Seasoning_svg__clip0_1120_204946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.682 4.525c0 .206-.17.375-.378.375h-1.818a.378.378 0 01-.378-.375v-.9c0-.206.17-.375.378-.375h1.818c.208 0 .378.169.378.375v.9z",
    fill: "#F6B142"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M16.918 4.525v-.9c0-.206.17-.375.378-.375h-.81a.378.378 0 00-.378.375v.9c0 .206.17.375.378.375h.81a.378.378 0 01-.378-.375z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.724 8.35L20.34 6.86h-5.89l-1.383 1.49a1.043 1.043 0 00-.277.708v9.402c0 .574.464 1.04 1.036 1.04h7.138c.572 0 1.037-.466 1.037-1.04V9.058c0-.263-.1-.516-.278-.709z",
    fill: "url(#Seasoning_svg__paint0_linear_1120_204946)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.79 11.115v7.344c0 .575.465 1.04 1.037 1.04h7.138c.572 0 1.037-.465 1.037-1.04v-7.344H12.79z",
    fill: "url(#Seasoning_svg__paint1_linear_1120_204946)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M14.123 18.46V9.058c0-.263.099-.516.278-.709l1.382-1.49H14.45l-1.383 1.49a1.043 1.043 0 00-.277.71v9.4c0 .575.464 1.041 1.036 1.041h1.332a1.039 1.039 0 01-1.036-1.04z",
    fill: "url(#Seasoning_svg__paint2_linear_1120_204946)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.246 4.46a.378.378 0 00-.378.375v.55c0 .205.17.374.378.374h6.3a.377.377 0 00.378-.375v-.55a.377.377 0 00-.378-.374h-6.3z",
    fill: "#FFCB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.246 5.759a.378.378 0 00-.378.375v.549c0 .206.17.375.378.375h6.3a.377.377 0 00.378-.375v-.55a.377.377 0 00-.378-.374h-6.3z",
    fill: "#F6B142"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M14.69 5.384v-.55c0-.205.17-.374.377-.374h-.821a.378.378 0 00-.378.375v.55c0 .205.17.374.378.374h.821a.378.378 0 01-.378-.375zM14.69 6.683v-.55c0-.205.17-.374.377-.374h-.821a.378.378 0 00-.378.375v.549c0 .206.17.375.378.375h.821a.378.378 0 01-.378-.375z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.395 14.971a2.517 2.517 0 002.526-2.507 2.517 2.517 0 00-2.526-2.507 2.517 2.517 0 00-2.527 2.507 2.517 2.517 0 002.527 2.507z",
    fill: "url(#Seasoning_svg__paint3_linear_1120_204946)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M15.898 12.464c0-1.21.863-2.219 2.011-2.455a2.555 2.555 0 00-.514-.052 2.517 2.517 0 00-2.527 2.507 2.517 2.517 0 002.527 2.507c.176 0 .348-.018.514-.052a2.513 2.513 0 01-2.011-2.455z",
    fill: "url(#Seasoning_svg__paint4_linear_1120_204946)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.395 15.244c-1.544 0-2.801-1.247-2.801-2.78 0-1.533 1.257-2.78 2.801-2.78 1.545 0 2.802 1.247 2.802 2.78 0 1.533-1.257 2.78-2.802 2.78zm0-5.014a2.245 2.245 0 00-2.251 2.234 2.245 2.245 0 002.251 2.234 2.245 2.245 0 002.252-2.234 2.245 2.245 0 00-2.252-2.234z",
    fill: "#CD7E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.437 12.399h-2.084a.274.274 0 01-.275-.273c0-.151.123-.274.275-.274h2.084a.274.274 0 110 .546zM18.084 13.488h-1.378a.274.274 0 01-.275-.273c0-.15.123-.273.275-.273h1.378c.152 0 .275.123.275.273 0 .151-.123.273-.275.273z",
    fill: "#CD7E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65 3.417c0 .206-.17.375-.378.375H7.219a.378.378 0 01-.377-.375V2.375c0-.206.17-.375.377-.375h2.053c.208 0 .378.169.378.375v1.042z",
    fill: "#009E7A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M7.66 3.417V2.375c0-.206.17-.375.378-.375H7.22a.378.378 0 00-.377.375v1.042c0 .206.17.375.377.375h.819a.378.378 0 01-.378-.375z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.968 7.538l-1.485-1.593H5.008L3.524 7.538a1.13 1.13 0 00-.304.77V18.37c0 .624.507 1.13 1.131 1.13h7.789a1.13 1.13 0 001.131-1.13V8.308c0-.286-.108-.561-.303-.77z",
    fill: "url(#Seasoning_svg__paint5_linear_1120_204946)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.22 10.542v7.828c0 .624.507 1.13 1.131 1.13h7.789a1.13 1.13 0 001.131-1.13v-7.828H3.221z",
    fill: "url(#Seasoning_svg__paint6_linear_1120_204946)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M4.449 18.37V8.308c0-.286.108-.561.303-.77l1.485-1.593H5.008L3.524 7.538a1.13 1.13 0 00-.304.77V18.37c0 .624.507 1.13 1.131 1.13h1.23a1.13 1.13 0 01-1.132-1.13z",
    fill: "url(#Seasoning_svg__paint7_linear_1120_204946)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.774 3.314a.378.378 0 00-.378.375v.661c0 .206.17.375.378.375h6.944a.378.378 0 00.378-.375v-.66a.378.378 0 00-.378-.376H4.774z",
    fill: "#82DDAB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M5.43 4.35v-.66c0-.207.17-.376.379-.376H4.774a.378.378 0 00-.378.375v.661c0 .206.17.375.378.375h1.035a.378.378 0 01-.378-.375z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.774 4.726a.378.378 0 00-.378.375v.66c0 .207.17.375.378.375h6.944a.378.378 0 00.378-.375v-.66a.378.378 0 00-.378-.375H4.774z",
    fill: "#4CCE87"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M5.43 5.761v-.66c0-.207.17-.375.379-.375H4.774a.378.378 0 00-.378.375v.66c0 .207.17.375.378.375h1.035a.378.378 0 01-.378-.375z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.247 14.958c1.523 0 2.757-1.22 2.757-2.723S9.77 9.513 8.247 9.513c-1.522 0-2.757 1.219-2.757 2.722 0 1.504 1.235 2.723 2.757 2.723z",
    fill: "url(#Seasoning_svg__paint8_linear_1120_204946)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M6.528 12.235c0-1.328.964-2.434 2.238-2.673a2.804 2.804 0 00-.519-.05c-1.522 0-2.757 1.22-2.757 2.723 0 1.504 1.235 2.723 2.757 2.723.178 0 .35-.018.52-.05-1.275-.239-2.239-1.344-2.239-2.673z",
    fill: "url(#Seasoning_svg__paint9_linear_1120_204946)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.248 15.231c-1.672 0-3.032-1.344-3.032-2.995 0-1.652 1.36-2.996 3.032-2.996s3.032 1.344 3.032 2.996c0 1.651-1.36 2.995-3.032 2.995zm0-5.445c-1.369 0-2.482 1.1-2.482 2.45s1.113 2.45 2.482 2.45c1.368 0 2.482-1.1 2.482-2.45s-1.114-2.45-2.482-2.45z",
    fill: "url(#Seasoning_svg__paint10_linear_1120_204946)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29 12.038H7.207a.274.274 0 01-.276-.273c0-.15.124-.273.276-.273H9.29c.152 0 .275.122.275.273 0 .151-.123.273-.275.273zM8.936 13.128H7.558a.274.274 0 01-.275-.273c0-.15.123-.273.275-.273h1.378c.152 0 .275.122.275.273 0 .15-.123.273-.275.273z",
    fill: "#84AA4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Seasoning_svg__paint0_linear_1120_204946",
    x1: 17.396,
    y1: 6.859,
    x2: 17.396,
    y2: 13.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96E1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Seasoning_svg__paint1_linear_1120_204946",
    x1: 17.396,
    y1: 11.115,
    x2: 17.396,
    y2: 19.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD38C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Seasoning_svg__paint2_linear_1120_204946",
    x1: 14.287,
    y1: 6.859,
    x2: 14.287,
    y2: 19.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Seasoning_svg__paint3_linear_1120_204946",
    x1: 17.395,
    y1: 9.957,
    x2: 17.395,
    y2: 14.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFBE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Seasoning_svg__paint4_linear_1120_204946",
    x1: 16.389,
    y1: 9.957,
    x2: 16.389,
    y2: 14.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Seasoning_svg__paint5_linear_1120_204946",
    x1: 8.246,
    y1: 5.945,
    x2: 8.246,
    y2: 14.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96E1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Seasoning_svg__paint6_linear_1120_204946",
    x1: 8.246,
    y1: 10.542,
    x2: 8.246,
    y2: 19.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFBF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDE7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Seasoning_svg__paint7_linear_1120_204946",
    x1: 4.729,
    y1: 5.945,
    x2: 4.729,
    y2: 19.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Seasoning_svg__paint8_linear_1120_204946",
    x1: 8.247,
    y1: 9.513,
    x2: 8.247,
    y2: 14.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFBE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Seasoning_svg__paint9_linear_1120_204946",
    x1: 7.128,
    y1: 9.513,
    x2: 7.128,
    y2: 14.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Seasoning_svg__paint10_linear_1120_204946",
    x1: 8.791,
    y1: 15.392,
    x2: 8.769,
    y2: 9.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D8F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98C25C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Seasoning_svg__clip0_1120_204946"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
};
export default __webpack_public_path__ + "static/media/Seasoning.7e0967cf.svg";
export { SvgSeasoning as ReactComponent };